// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@/modules/common/components/Card';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';
import '../../styles/Alarm/Alarm.scss';

const initialValues = {
    interval1: 0,
    interval2: 0,
    httpTimeout: 0,
    errorMessage1Format: '',
    errorMessage2Format: '',
};

const initialErrors = {
    interval1: '',
    interval2: '',
    httpTimeout: '',
    errorMessage1Format: '',
    errorMessage2Format: '',
};

let abortController1;
let abortController2;

const Alarm = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);

    const { enqueueSnackbar } = useSnackbar();

    const fetch = () => {
        abortController1 = new AbortController();
        setLoading(true);
        props.fetch.get('/api/cfg/alarm/', abortController1)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController1 = null;
            });
    };

    useEffect(() => {
        fetch();
        return () => {
            if (abortController1) {
                abortController1.abort();
            }
            if (abortController2) {
                abortController2.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (data) {
            setValues({
                interval1: data.interval1,
                interval2: data.interval2,
                httpTimeout: data.http_timeout,
                errorMessage1Format: data.error_message1_format,
                errorMessage2Format: data.error_message2_format,
            });
        }
    }, [data]);

    const handleSubmit = (event) => {
        abortController2 = new AbortController();
        setFetching(true);
        event.preventDefault();
        props.fetch.put(
            '/api/cfg/alarm/', {
                interval1: values.interval1,
                interval2: values.interval2,
                http_timeout: values.httpTimeout,
                error_message1_format: values.errorMessage1Format,
                error_message2_format: values.errorMessage2Format,
            },
            abortController2
        ).then(({ok, data}) => {
            if (ok) {
                enqueueSnackbar('Настройки обновлены', {variant: 'success'});
            }
            else {
                let _errors = {...initialErrors};
                _errors.interval1 = (data.interval1) ? data.interval1[0] : '';
                _errors.interval2 = (data.interval2) ? data.interval2[0] : '';
                _errors.httpTimeout = (data.http_timeout) ? data.http_timeout[0] : '';
                _errors.errorMessage1Format = (data.error_message1_format) ? data.error_message1_format[0] : '';
                _errors.errorMessage2Format = (data.error_message2_format) ? data.error_message2_format[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController2 = null;
        });
    };

    return (
        <Card>
            <CardHeader title="Уведомления"/>
            <CardContent className={(loading) ? 'loading' : ''}>
                {(!loading)
                    ? <>
                        {(data)
                            ? <>
                                <Form values={values} setValues={setValues}
                                      errors={errors} setErrors={setErrors}
                                      onSubmit={handleSubmit} disabled={fetching}
                                />
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </CardContent>
        </Card>
    );
};

let Component = Alarm;
Component = withFetch(Component);

export default Component;
